import React, { useEffect, useState } from 'react';
import Loading from '../../loading/Loading';
import TableLayout, { TD } from '../../ui/TableLayout';
import { EditBtn, DeleteBtn, Actions } from '../../ui/ActionButtons';
import Apis from '../../Apis';
import axios from 'axios';

const COLS = ['Nome da Rota', 'Ações'];
const headers = () => ({ 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') });

export default function ListaRotas() {
  const [search, setSearch]   = useState('');
  const [perPage, setPerPage] = useState(25);
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = (q = search, pp = perPage) => {
    setLoading(true);
    axios.get(
      `${Apis.urlListarRotas}?pesquisa=${q}&qtd_registros=${pp}`,
      { headers: headers() }
    )
      .then(res => setData(res.data.registros || []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchData(); }, []); // eslint-disable-line

  const handlePerPage = (val) => { setPerPage(val); fetchData(search, val); };

  if (loading) return <Loading />;

  return (
    <TableLayout
      title="Lista de Rotas"
      icon={null}
      count={data.length}
      columns={COLS}
      search={{ value: search, onChange: setSearch, placeholder: 'Buscar por nome da rota…', onSubmit: () => fetchData() }}
      pagination={{ value: perPage, onChange: handlePerPage }}
      fab={{ show: true, label: 'rota', path: 'cadastrar-rotas' }}
      emptyMessage="Nenhuma rota encontrada."
    >
      {data.map((c, i) => (
        <tr key={c.id}
          style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc' }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#eff6ff')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#fff' : '#f8fafc')}
        >
          <TD left uppercase>{c.nome}</TD>
          <TD>
            <Actions>
              <EditBtn to={`/alterar-rotas/${c.id}`} />
              <DeleteBtn url={Apis.urlDeletarRotas} id={c.id} redirect="listar-rotas" component="Rota" texto={`Deseja realmente excluir a rota ${c.nome}`} />
            </Actions>
          </TD>
        </tr>
      ))}
    </TableLayout>
  );
}
